import { customEvent } from "./customEvent";
import { LeadUrgency, getLeadUrgencyEventKey } from "../constants/leadUrgency";

export type LeadSubmitType = "checklist" | "home";

/**
 * v2 통합 리드(POST /v2/leads/) 제출 성공 시 집계용 이벤트 발화.
 *
 * 총량(lead_submit)과 리드종류별(lead_submit_{type})을 같이 쏜다.
 * 견적의 match_request_complete + guest_submit_* 와 같은 패턴.
 * 화면별 성공 이벤트(submit_success, quote_success 등)는 각 호출부가 그대로 발화한다.
 *
 * 발화 위치는 useSubmitLead 훅(platform, ssr-platform)과
 * parlor raw 호출부. API 레이어는 이 함수를 모른다.
 *
 * @param urgency 리드의 임박도(`body.status`). 광고 전환가치용 `goi_lead_{임박도}` 에만 쓴다.
 *   임박도 문항이 없는 화면은 넘기지 않으며 그때는 `goi_lead_unknown` 으로 발화한다.
 *   기존 `lead_submit*` 2종의 동작은 이 인자와 무관하게 그대로다.
 */
export const fireLeadSubmitEvents = (
  leadType: LeadSubmitType,
  urgency?: LeadUrgency
) => {
  if (typeof window === "undefined") return;

  try {
    customEvent({
      newGtm: { action: "lead_submit", properties: { lead_type: leadType } },
    });
    customEvent({ newGtm: { action: `lead_submit_${leadType}` } });
    customEvent({
      newGtm: { action: `goi_lead_${getLeadUrgencyEventKey(urgency)}` },
    });
  } catch (e) {
    // POST 는 이미 성공한 상태다. 이벤트 실패가 호출부 catch 로 번져서
    // "제출 실패" 안내를 띄우면 안 된다.
    console.error("lead_submit 이벤트 발화 실패:", e);
  }
};
